import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from 'Components/UI/Button';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {},
});

/* If value is true or false, Yes or No will be highlighted, respectively. If value is null or undefined, neither will be. */
const YesNoToggleButtons = ({
  classes,
  className,
  value,
  onChange,
  yesLabelOverride,
  noLabelOverride,
  YesButtonProps,
  NoButtonProps,
  fullWidth,
}) => {
  return (
    <ButtonGroup className={classNames(classes.root, className)} fullWidth={fullWidth}>
      <Button
        color={value ? 'primary' : 'gray'}
        variant={value ? 'contained' : 'outlined'}
        onClick={() => {
          if (value) {
            onChange(null);
          } else {
            onChange(true);
          }
        }}
        {...YesButtonProps}
      >
        {yesLabelOverride || 'Yes'}
      </Button>
      <Button
        color={value === false ? 'primary' : 'gray'}
        variant={value === false ? 'contained' : 'outlined'}
        onClick={() => {
          onChange(false);
          if (value === false) {
            onChange(null);
          } else {
            onChange(false);
          }
        }}
        {...NoButtonProps}
      >
        {noLabelOverride || 'No'}
      </Button>
    </ButtonGroup>
  );
};

YesNoToggleButtons.defaultProps = {
  classes: {},
  className: '',
  yesLabelOverride: null,
  noLabelOverride: null,
  YesButtonProps: {
    test: 'yes-no-toggle-yes-button',
  },
  NoButtonProps: {
    test: 'yes-no-toggle-no-button',
  },
  fullWidth: true,
};

YesNoToggleButtons.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  yesLabelOverride: PropTypes.string,
  noLabelOverride: PropTypes.string,
  YesButtonProps: PropTypes.object,
  NoButtonProps: PropTypes.object,
  fullWidth: PropTypes.bool,
};

export default withStyles(styles)(YesNoToggleButtons);
